import React from 'react'
import Image from '../../../images/buyerpolicies/KAAY Closet.png'

const Kaay_closet = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>KAAY Closet</h2>
            <p>KAAY will provide an Inspection of the product ordered. </p>
            <p>After the seller receives the order, he/she will dispatch the product to our Headquarters and we have a professional quality audit team. The product will get inspected as per described quality and if there are some flaws that are not mentioned in the description then KAAY will send it back to the seller, otherwise, KAAY will dispatch it to the buyer.</p>
            <p>There is no claim in KAAY Closet as KAAY is inspecting the product by itself.</p>
        </div>
      </div>
    </div>
  )
}

export default Kaay_closet
